import {useEffect, useRef, useState} from "react";
import {AdvertisementAction} from "../state/types";
import {useDispatch} from "react-redux";


export const useRefresh = (use: number) => {
    // hlidani resize, scroll
    const dispatch = useDispatch();
    const [state, setState] = useState(0)
    const rState = useRef(state);
    rState.current = state;
    const rFuncs = useRef<() => void>(() => {
        setState(rState.current + 1);
    });

    useEffect(() => {
        if (use) {
            dispatch<AdvertisementAction>({
                type: "AdvertisementBegin"
            })
            window.addEventListener('resize', rFuncs.current);
            window.addEventListener('scroll', rFuncs.current);
        } else if (!use) {
            window.removeEventListener('resize', rFuncs.current);
            window.removeEventListener('scroll', rFuncs.current);
        }
        // eslint-disable-next-line
    }, [use]);

    useEffect(() => {
        return () => {
            // eslint-disable-next-line
            const cur = rFuncs.current;
            window.removeEventListener('resize', cur);
            window.removeEventListener('scroll', cur);
        }
    }, [])

    return rFuncs.current;
}